var ProgramEditController = (function () {
    function ProgramEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.id = '';
        this.original = { _id: '' }; //for future logging reference at save time
        this.select = {
            countries: {}, brands: {}, bp_types: {}, hasPreApproval: false,
            preapproval: { stages: {}, stages_ordered: [], stages_ordered_text: [] },
            approval: { stages: {}, stages_ordered: [], stages_ordered_text: [] }
        };
        this.selectValid = false;
        this.valid = { approval: false, preapproval: false };
        this.readyMan = false;
        this.appProcesses = ['approval', 'preapproval'];
        this.newProfile = false;
        this.events = { beingSaved: false, beingDeleted: false };
        this.combinations = 0;
        this.conflicts = {
            keys: false, profile_id: '', viewDetails: false, resolved: false
        };
        this.serverError = null;
        this.id = $stateParams.id;
        this.socket.forward('config.program_by_name', this.$scope);
        this.$scope.$on('socket:config.program_by_name', function (event, data) {
            _this.$timeout(function () {
                _this.setProgramData(data);
            }, 1000); //hmm..naughty
        });
    }
    ProgramEditController.prototype.newLine = function (index, cols) {
        if (index % cols === 0) {
            return true;
        }
        else {
            return false;
        }
    };
    ProgramEditController.prototype.setProgramData = function (data) {
        this.editing = data;
        angular.copy(data, this.original); //for logging etc
        this.select.countries = this.prepareCountries(this.editing.imt);
        this.select.brands = this.prepareGenerals('brands');
        this.select.bp_types = this.prepareGenerals('bp_types');
        this.prepareAppStages('approval', 5);
        this.prepareAppStages('preapproval', 2);
        this.select.approval.stages_ordered = this.editing.approval_stages;
        this.select.preapproval.stages_ordered = this.editing.preapproval_stages;
        this.setCombinations();
        this.readyMan = true;
    };
    ProgramEditController.prototype.removeConflicts = function () {
        var _this = this;
        var tempEditCty = [];
        angular.copy(this.editing.countries, tempEditCty); //Create copy to loop through since original will change
        //All I can think to do here is remove the offending countries from selection
        angular.forEach(tempEditCty, function (cty) {
            angular.forEach(_this.conflicts.details, function (dupe) {
                if (dupe.cty === cty) {
                    _this.editing.countries.splice(_this.editing.countries.indexOf(cty), 1); //remove from short array
                    //Loop through selected array and set to false
                    angular.forEach(_this.select.countries, function (value, key) {
                        if (key === cty) {
                            _this.select.countries[key] = false;
                        }
                    });
                }
            });
        });
        this.sync('countries');
        this.conflicts.resolved = true;
    };
    ProgramEditController.prototype.conflictsFound = function (data) {
        var _this = this;
        this.conflicts.keys = true; //Set flag to show conflict on keys
        this.conflicts.details = data.data; //set the data
        this.conflicts.headers = [{
                'Profile ID': 'profile_id', 'Brand': 'brand', 'BP Type': 'bp_type',
                'Abbr': 'cty', 'Country Name': 'country'
            }];
        //Loop through and update the country names for display
        angular.forEach(this.settings.country_list, function (cty) {
            if (cty.imt === _this.editing.imt) {
                //if (cty.imt === 'Europe IOT') {
                angular.forEach(_this.conflicts.details, function (dupe) {
                    if (cty.short === dupe.cty) {
                        dupe.country = cty.country;
                    }
                });
            }
        });
    };
    ProgramEditController.prototype.iotChange = function () {
        this.select.countries = {};
        this.sync('countries');
    };
    ProgramEditController.prototype.syncAppStages = function (stageNo, appProcess, appPN) {
        var currentIndexNo = this.select[appProcess].stages_ordered.indexOf(stageNo);
        //check if that stage is in the ordered list or not
        if (currentIndexNo > -1) {
            //If so, assume it needs deleting
            this.select[appProcess].stages_ordered.splice(currentIndexNo, 1);
            this.select[appProcess].stages_ordered_text.splice(currentIndexNo, 1);
        }
        else {
            //If not, add it to the end..
            this.select[appProcess].stages_ordered.push(stageNo);
            this.select[appProcess].stages_ordered_text.push(this.config.getSubStatusBySubStatusNo2(appPN, stageNo).txt);
        }
        this.areApprovalsValid();
    };
    ProgramEditController.prototype.sync = function (field) {
        var _this = this;
        var ignore = ['preapproval', 'approval'];
        var newArray = [];
        angular.forEach(this.select[field], function (value, key) {
            if (value && ignore.indexOf(key) === -1) {
                newArray.push(key);
            }
        });
        this.editing[field] = newArray;
        var sv = 0;
        angular.forEach(this.select, function (value, key) {
            if (ignore.indexOf(key) && angular.isDefined(_this.editing[key]) && _this.editing[key].length > 0) {
                sv++;
            }
        });
        if (sv !== 3) {
            this.selectValid = false;
        }
        else {
            this.selectValid = true;
        }
        this.setCombinations();
    };
    ProgramEditController.prototype.prepareCountries = function (imt) {
        var _this = this;
        var newCountries = {};
        angular.forEach(this.settings.country_list, function (cty) {
            if (cty.imt === imt && _this.editing.countries.indexOf(cty.short) > -1) {
                newCountries[cty.short] = true;
            }
        });
        return newCountries;
    };
    ProgramEditController.prototype.prepareGenerals = function (field) {
        var _this = this;
        var newObject = {};
        angular.forEach(this.settings[field], function (x) {
            if (_this.editing[field].indexOf(x) > -1) {
                newObject[x] = true;
            }
        });
        return newObject;
    };
    ProgramEditController.prototype.getAppStages = function (appStage) {
        var stages = 'approval_stages';
        if (appStage === 'preapproval') {
            stages = 'preapproval_stages';
        }
        return stages;
    };
    ProgramEditController.prototype.prepareAppStages = function (appProcess, appPN) {
        var _this = this;
        var newStages = {};
        angular.forEach(this.config.getSubStatusesByMainStatusNo(appPN), function (stage) {
            if (_this.editing[_this.getAppStages(appProcess)].indexOf(stage.no) > -1) {
                newStages[stage.no] = true;
            }
        });
        this.select[appProcess].stages = newStages;
        var newStages_Text = [];
        angular.forEach(this.editing[this.getAppStages(appProcess)], function (stage) {
            var stg = _this.config.getSubStatusBySubStatusNo2(appPN, stage);
            if (stg !== null) {
                newStages_Text.push(_this.config.getSubStatusBySubStatusNo2(appPN, stage).txt);
            }
        });
        this.select[appProcess].stages_ordered_text = newStages_Text;
        if (newStages_Text.length > 0 && appPN === 2) {
            this.select.hasPreApproval = true;
        }
    };
    /**
      confirmDelete - Ask user to confirm if they wanna delete or not...just incase they click by mistake
      @param {IAngularEvent} event   event
      @returns void
    */
    ProgramEditController.prototype.confirmDelete = function (event) {
        var _this = this;
        var items = {
            title: 'Delete Program Profile',
            message: 'Are you sure you want to Delete this Program Profile?',
            icon: 'QUESTION'
        };
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.delete(event);
            }
        });
    };
    ProgramEditController.prototype.delete = function (event) {
        var _this = this;
        this.events.beingDeleted = true;
        this.serverError = null;
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.deletePromise().then(function (data) {
            //If response from server received
            _this.events.beingDeleted = false; //enable again
            if (data.error) {
                _this.serverError = data.error;
            }
            else {
                _this.admin.navigate('admin.program-view');
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    ProgramEditController.prototype.setCombinations = function () {
        var _this = this;
        var count = 0;
        angular.forEach(this.editing.countries, function (cty) {
            angular.forEach(_this.editing.brands, function (brand) {
                angular.forEach(_this.editing.bp_types, function (bp) {
                    count++;
                });
            });
        });
        this.combinations = count;
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    ProgramEditController.prototype.save = function (event) {
        var _this = this;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        this.conflicts = {}; //reset conflicts
        /*
        Removed since the main status flow is now under the Program Profile - it is assumed (yikes!) that the main
        status flow for a Program will be the same worldwide!
                if (this.newProfile) {
        
                    //If new profile, set the status flow
                    let statusflow: any = [1, 3, 4, 5, 6, 7, 8];
                    if (this.editing.preapproval_stages.length > 0) {
                        statusflow = [1, 2, 3, 4, 5, 6, 7, 8];
                    }
        
                    this.editing.status_flow = statusflow;
        
                }
                */
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise().then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            if (data.error) {
                if (data.error.indexOf('Duplicates') > -1) {
                    _this.conflictsFound(data);
                }
                else if (data.error.indexOf('Conflicting Profile') > -1) {
                    _this.conflicts.profile_id = _this.editing.profile_id;
                }
                else {
                    _this.serverError = data.error;
                }
            }
            else {
                _this.admin.navigate('admin.program-view');
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    ProgramEditController.prototype.$onInit = function () {
        //this.admin.getCountryConfig();
        //this.admin.getGeneralConfig();
        var _this = this;
        if (this.id !== '') {
            //Get details
            this.admin.getProgramProfileByName(this.id);
            this.selectValid = true;
            this.valid = { approval: true, preapproval: true };
        }
        else {
            this.newProfile = true;
            this.editing = { countries: [], type: 'program3', onshore_offshore: '' };
            angular.forEach(this.appProcesses, function (appProcess) {
                _this.editing[_this.getAppStages(appProcess)] = [];
                _this.select[appProcess].stages_ordered = _this.editing[_this.getAppStages(appProcess)]; //this binds the two somehow!
                _this.select[appProcess].stages_ordered_text = [];
            });
            this.readyMan = true;
        }
    };
    ProgramEditController.prototype.selectAll = function (tf) {
        var _this = this;
        if (!tf) {
            this.select.countries = {};
        }
        else {
            angular.forEach(this.settings.country_list, function (cty) {
                if (cty.imt === _this.editing.imt && cty.ic === 'Country') {
                    _this.select.countries[cty.short] = true;
                }
            });
        }
        this.sync('countries');
    };
    ProgramEditController.prototype.areApprovalsValid = function () {
        var _this = this;
        var appProcesses = ['approval', 'preapproval'];
        angular.forEach(this.appProcesses, function (appProcess) {
            //Set form validity
            if (_this.select[appProcess].stages_ordered.length > 0) {
                _this.valid[appProcess] = true;
            }
            else {
                _this.valid[appProcess] = false;
                if (appProcess === 'preapproval' && !_this.select.hasPreApproval) {
                    _this.valid[appProcess] = true; //actually ok
                }
            }
        });
    };
    ProgramEditController.prototype.wipeApprovals = function (appProcess) {
        var _this = this;
        angular.forEach(this.select[appProcess].stages, function (value, key) {
            _this.select[appProcess].stages[key] = false;
        });
        this.editing[this.getAppStages(appProcess)] = [];
        this.select[appProcess].stages_ordered = this.editing[this.getAppStages(appProcess)]; //this binds the two somehow!
        this.select[appProcess].stages_ordered_text = [];
        this.areApprovalsValid();
    };
    ProgramEditController.prototype.selectAll2 = function (tf, field) {
        var _this = this;
        if (!tf) {
            this.select[field] = {};
        }
        else {
            //angular.forEach(this.admin.general[field], (x) => {
            angular.forEach(this.settings[field], function (x) {
                _this.select[field][x] = true;
            });
        }
        this.sync(field);
    };
    ProgramEditController.prototype.displayPrompt = function (event, bundle, icon) {
        var items = {
            title: bundle.title,
            message: bundle.textContent,
            icon: icon //ERROR, INFO, WARN
        };
        this.Dialog.openDialog(event, items, DialogService, 'confirm-prompt.html');
    };
    ProgramEditController.prototype.savePromise = function () {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.admin.updateAdminProfile(this.editing);
        this.socket.forward('config.admin_update', this.$scope);
        this.$scope.$on('socket:config.admin_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
            //Once done saving, send email to Admin team
            var emailBundle = { docurl: 'program/' + _this.id, profile: 'Program Workflow Profile (' + _this.editing.profile_id + ')', user: _this.env.user };
            _this.admin.sendAdminUpdate(emailBundle);
        });
        return this.deferred.promise; //fire off the promise
    };
    ProgramEditController.prototype.deletePromise = function () {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        var delPackage = { _id: this.editing._id, _rev: this.editing._rev, profile_id: this.editing.profile_id };
        this.admin.deleteAdminProfile(delPackage);
        this.socket.forward('config.admin_delete', this.$scope);
        this.$scope.$on('socket:config.admin_delete', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    ProgramEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings'];
    return ProgramEditController;
}());
var ProgramEditComponent = (function () {
    function ProgramEditComponent() {
        this.templateUrl = 'program.html';
        this.controllerAs = 'vm';
        this.controller = ProgramEditController;
    }
    return ProgramEditComponent;
}());
angular
    .module('application')
    .component('adminProgramSection', new ProgramEditComponent());

//# sourceMappingURL=program.edit.component.js.map
